module.exports = __webpack_public_path__ + "img/how-icon-3-call.4989abd0.png";